import axiosInstance from "../../../axios";
import AXIOS_ROUTES from "../../../axios/routes";

export const getActiveTrainingPrograms = async (
  userId: string,
) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.journals.getActiveTrainingPrograms}?userId=${userId}`
  );
};

export const getUnfinishedTrainingPrograms = async (
  userId: string,
  skip: number,
  limit: number
) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.journals.getUnfinishedTrainingPrograms}?skip=${skip}&limit=${limit}&userId=${userId}`
  );
};

export const getFinishedTrainingPrograms = async (
  userId: string,
  skip: number,
  limit: number
) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.journals.getFinishedTrainingPrograms}?skip=${skip}&limit=${limit}&userId=${userId}`
  );
};
